import { LoginPassword } from "./login-password";
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from "@angular/common/http";
import { UrlsResources } from "../urls-resources";
import { LocalStorage } from "../storage/storage-decorator";
import { Observable } from "rxjs/Observable";
import * as jwt_decode from 'jwt-decode';
import * as moment from 'moment';
import * as _ from 'lodash';
import { LocalStorageService } from "../storage/storage.service";
import { UserInfo } from "./user-info";
import { CustomerModel } from "./customer.model";
import { HandleError } from '../handle-error';

export abstract class AuthService{

  private options = {
    headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
  };

  private _user: CustomerModel = null;

  get user(): CustomerModel {
    // console.log('usuario: ', this._user);
    //this.balance.next(this._user != null ? (this._user.balance != null ? parseFloat(this._user.balance) : 0) : 0);
    return this._user;
  }

  @LocalStorage() private jwtToken;
  @LocalStorage() private refreshToken;

  decodedJwtToken;

  constructor(protected httpClient: HttpClient,
    protected urlsResources: UrlsResources,
    protected handleError: HandleError,
    protected localStorageService: LocalStorageService) {
    //console.log("AuthService:constructor:jwtToken", this.jwtToken);
    if (this.jwtToken) {
      this.decodedJwtToken = jwt_decode(this.jwtToken);

    }
  }

  signIn(loginPassword: LoginPassword): Observable<object> {
    const request = {
      grant_type: "password",
      username: loginPassword.userId,
      password: loginPassword.password
    };
    const body = new URLSearchParams();
    body.set('grant_type', "password");
    body.set('username', loginPassword.userId);
    body.set('password', loginPassword.password);
    return this.httpClient.post(this.urlsResources.getSignInUrl(), body.toString(), this.options).do((r) => {
      this.handleTokenInResponse(r);
    });
  }

  setUserInfo(user: CustomerModel) {
    this._user = user;
    //return Observable.fromPromise(this._storage.setUser(JSON.stringify(this._user)));
  }

  /**
   * Se obtiene el customer
   *
   */
  getCustomerByUsername(): Observable<CustomerModel> {
    //this.authHttp.patch
    const httpOptions = {
      withCredentials: true
    };
    return this.httpClient.get<CustomerModel>(this.urlsResources.customerUrl(), httpOptions)
      .map(response => {

        this.setUserInfo(response)
        return response;
      })
      .catch(err => {
        return this.handleError.handleErrorAsObservable(err)
      });
  }

  private handleTokenInResponse(response: any) {

    //console.log("AuthService:handleTokenInResponse", response);
    this.jwtToken = response.access_token;
    this.saveRefreshToken(response);
    this.decodedJwtToken = jwt_decode(this.jwtToken);
    //console.log("AuthService:handleTokenInResponse:decodedJwt", this.decodedJwtToken);
  }

  isSessionValid(): Observable<boolean> {
    if (this.decodedJwtToken) {
      //console.log("AuthService:isSessionValid:decodedJwt", this.decodedJwtToken);
      const rightNow = moment();
      //console.log("AuthService:isSessionValid:rightNow", rightNow);
      const expirationDate = moment.unix(this.decodedJwtToken.exp);
      //console.log("AuthService:isSessionValid:expirationDate", expirationDate);
      const diff = expirationDate.diff(rightNow);
      //console.log("AuthService:isSessionValid:diff", diff);
      if (diff > 0) {
        return Observable.from([true]);
      } else {
        return this.refreshExpiredToken().map((httpResponse) => {
          //console.log("AuthService:refreshExpiredToken:httpResponse", httpResponse);
          this.handleTokenInResponse(httpResponse);
          return true;
        }).catch((err: HttpErrorResponse) => {
          console.log('Error validating session', err);
          this.signOut();
          this.goToLoginPage();
          return Observable.throw(err);
        });
      }

    } else {
      return Observable.from([false]);
    }
  }

  getToken(): string {
    return this.jwtToken;
  }

  signOut() {
    this.decodedJwtToken = null;
    this.jwtToken = null;
    this.localStorageService.clear();
    this.goToLoginPage();
  }

  abstract goToLoginPage();

  private saveRefreshToken(response) {
    this.refreshToken = response.refresh_token;
  }

  private refreshExpiredToken(): Observable<Object> {
    //console.log("AuthService:refreshExpiredToken");
    const body = new URLSearchParams();
    body.set('grant_type', "refresh_token");
    body.set('refresh_token', this.refreshToken);
    return this.httpClient.post(this.urlsResources.getRefreshTokenUrl(), body.toString(), this.options).do((r) => this.handleTokenInResponse(r));
  }

  public getUserInfo(): UserInfo {
    if (this.decodedJwtToken) {
      return new UserInfo(this.decodedJwtToken.user_name);
    } else {
      return null;
    }
  }

  public hasAccessRoles(roles: Array<string>): boolean {
    return _.find(roles, (role) => {
      return _.indexOf(this.decodedJwtToken.authorities, role) > -1;
    }) !== undefined;
  }

  public isScopeForThisSite(scope: string) {
    return _.indexOf(this.decodedJwtToken.scope, scope) > -1;
  }
}




// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/auth/auth.service.ts